
import pageSlugs from '@src/components/layout/pageSlugs';
import ChevronDownIcon from '@src/assets/icons/chevron-down.svg';
import CirclesPurpleIcon from '@src/assets/icons/circles-purple.svg';
import { renderHtmlToReact } from '@src/utils/html';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

const dukSection = ({
  title,
  questions,
  countToShow,
  showButtonToDuk,
  showCircles = true,
}) => {
  const { t, i18n } = useTranslation();
  const [questionsToShow, setQuestionsToShow] = useState(countToShow || 5);
  const wrapperRef = useRef(null);

  const hideAllAnswers = () => {
    wrapperRef.current.querySelectorAll('.active').forEach((elem) => {
      elem.classList.remove('active');
    });
  };

  const handleShowAnswer = (event) => {
    const questionElement = event.currentTarget.parentElement;

    if (!questionElement.classList.contains('active')) {
      hideAllAnswers();
    }
    questionElement.classList.toggle('active');
  };

  const handleLoadMoreQuestions = () => {
    setQuestionsToShow(questionsToShow + 5);
  };

  return (
    <>
      {questions && questions.length && (
        <div className="relative">
          {showCircles && (
            <CirclesPurpleIcon className="circle-bottom-right circle-green" />
          )}

          <Container px={4} py={6}>
            {title && (
              <Themed.h2 sx={{ textAlign: 'center' }}>{title}</Themed.h2>
            )}

            <Container
              sx={{
                maxWidth: '1000px',
                margin: 'auto',
              }}
              ref={wrapperRef}
            >
              {questions.slice(0, questionsToShow).map((item) => (
                <Box
                  sx={{
                    position: 'relative',
                    padding: '20px 32px',
                    backgroundColor: 'white',
                    borderRadius: '10px',
                    boxShadow: '0px 10px 20px #0000000F',
                    marginBottom: '8px',
                  }}
                  key={item.question}
                >
                  <Themed.h5
                    className="duk-title"
                    sx={{ margin: '0' }}
                    onClick={handleShowAnswer}
                  >
                    {item.question}
                  </Themed.h5>
                  <Box className="duk-answer">
                    {item?.answer?.childMarkdownRemark?.htmlAst &&
                      renderHtmlToReact(
                        item.answer.childMarkdownRemark.htmlAst
                      )}
                  </Box>
                  <Box
                    sx={{
                      pointerEvents: 'none',
                      position: 'absolute',
                      right: '32px',
                      top: '20px',
                    }}
                  >
                    <ChevronDownIcon className="duk-toggle-icon" />
                  </Box>
                </Box>
              ))}

              {questions.length > questionsToShow ? (
                <Box
                  py={4}
                  sx={{
                    textAlign: 'center',
                    position: 'relative',
                  }}
                >
                  <Button onClick={handleLoadMoreQuestions}>
                    {t('showMore')}
                  </Button>
                </Box>
              ) : (
                <>
                  {showButtonToDuk && (
                    <Box py={4} sx={{ textAlign: 'center' }}>
                      <Link to={`/${pageSlugs.duk[i18n.language]}`}>
                        <Button>{t('helpCenter')}</Button>
                      </Link>
                    </Box>
                  )}
                </>
              )}
            </Container>
          </Container>
        </div>
      )}
    </>
  );
};

export default dukSection;

dukSection.propTypes = {
  title: PropTypes.string,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
    })
  ).isRequired,
};
